export const pianoErrorCodes = {
  invalidPasswordError: 1419,
  noPermissionError: 403,
  passwordLessLoginError: 1434,
  userExistsError: 1213,
  userNotFoundError: 2004,
  validationError: 400,
};
